import axios from "axios";

// Action types
export const POST_FEEDBACK_REQUEST = 'POST_FEEDBACK_REQUEST';
export const POST_FEEDBACK_SUCCESS = 'POST_FEEDBACK_SUCCESS';
export const POST_FEEDBACK_FAILURE = 'POST_FEEDBACK_FAILURE';

// Action creators
export const postFeedbackRequest = () => ({ type: POST_FEEDBACK_REQUEST });
export const postFeedbackSuccess = () => ({ type: POST_FEEDBACK_SUCCESS });
export const postFeedbackFailure = (error) => ({ type: POST_FEEDBACK_FAILURE, payload: error });

// Async action using Redux Thunk
export const postFeedback = (feedbackData) => async (dispatch) => {
  dispatch(postFeedbackRequest());
  try {
    console.log(feedbackData)
    await axios.post('http://localhost:5000/api/v1/feedback/new', feedbackData);
    dispatch(postFeedbackSuccess());
  } catch (error) {
    console.log("payload")
    dispatch(postFeedbackFailure(error.message));
    return error
  }
};